import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {AuthService} from './services/auth.service';
import {environment} from '../environments/environment';
import {NgSelectConfig} from '@ng-select/ng-select';
import {NavigationCancel, Router} from '@angular/router';
import {NavigationService} from './services/navigation.service';
import {MsalBroadcastService, MsalService} from '@azure/msal-angular';
import {InteractionStatus} from '@azure/msal-browser';
import {Subject} from 'rxjs';
import {filter, take, takeUntil} from 'rxjs/operators';

export const PRE_LOGIN_PATH = 'PRE_LOGIN_URL'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    authService = inject<AuthService>('AuthService' as any);
    private navigationService = inject(NavigationService);
    private router = inject(Router);
    private ngSelectConfig = inject(NgSelectConfig);
    private msalBroadcastService = inject(MsalBroadcastService);
    private msalService = inject(MsalService);
    private readonly destroying$ = new Subject<void>();


    constructor() {
        this.navigationService.initialize()
        this.setupLocalization()

        // Store current url when navigation to /login so we can navigate back after successful login
        this.router.events.subscribe(event => {
            if(event instanceof NavigationCancel) {
                sessionStorage.setItem(PRE_LOGIN_PATH, window.location.href);
            }
        })
    }

    setupLocalization() {
        this.ngSelectConfig.addTagText = 'Voeg toe';
        this.ngSelectConfig.loadingText = 'Laden...';
        this.ngSelectConfig.notFoundText = 'Geen resultaten';
        this.ngSelectConfig.typeToSearchText = 'Type om te zoeken';
    }

    ngOnInit() {
        if (environment.useMock) {
            document.body.classList.add('e2e-test');
            this.authService.initialize();
            return;
        }

        // MSAL v4 requires initialize() and any redirect handling to finish
        // before app code calls MSAL APIs. Wait for both InteractionStatus.None
        // AND an account in cache - the latter ensures handleRedirectObservable
        // has actually populated accounts (a bare None can fire before the
        // redirect is processed because AppComponent bootstraps before
        // MsalRedirectComponent).
        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) =>
                    status === InteractionStatus.None &&
                    this.msalService.instance.getAllAccounts().length > 0
                ),
                take(1),
                takeUntil(this.destroying$)
            )
            .subscribe(() => {
                this.authService.initialize();
            });
    }

    ngOnDestroy() {
        this.destroying$.next();
        this.destroying$.complete();
    }
}
